import { Component } from '@angular/core';

// web/error.html is the same markup nginx serves as the static error page. It was previously
// referenced as templateUrl: '/error.html', a server-absolute URL resolved by an XHR under JIT
// that the AOT compiler cannot resolve at build time (NG2008). Requiring it inlines the markup
// at compile time instead — the same thing plugins/chat/gf-chat.module.ts already does with it.
@Component({
    selector: 'error-block',
    template: require('../../../../../error.html')
})
export class ErrorBlockComponent {
    constructor(
    ) { }
}


